export const NBSP = ' ';

//Regex
export const REGEX_CAMEL_TO_SPACE = /([a-z])([A-Z])/g;
export const REGEX_UNDERSCORE_TO_SPACE = /_/g;
export const REGEX_CAPITALIZE_WORD = /\b\w/g;
export const OUNCE_TO_GRAMS = 28.3495;
export const FLUID_OUNCE_TO_MILLILITERS = 29.5735;